import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute bottom-0 right-0 flex items-baseline md:flex-col md:items-end gap-x1"
}
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "absolute bottom-0 right-0"
}
const _hoisted_7 = ["src", "alt"]

import useGlobalLabels from '@/shared/content/useGlobalLabels';
import generateCdnUrlWithParams from '@/core/responsive/image/helpers/generate-cdn-url-including-params';
import { GlobalLabels } from '@/shared/content/site-context.store';
import dictionaryService from '@/core/dictionary/dictionary.service';
import { computed } from 'vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import { Certificate, LightingSpecification } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailCertification',
  props: {
    productCertificationPrimary: null,
    lightingSpecification: null
  },
  setup(__props: any) {

const props = __props as {
    productCertificationPrimary?: Certificate,
    lightingSpecification: LightingSpecification | null,
}



const globalLabels = useGlobalLabels(GlobalLabels.product);

const imageHasLink = computed(() => {
    return props.lightingSpecification?.energyClassificationUrl;
});

const showLink = computed(() => {
    return props.lightingSpecification?.specificationUrl && globalLabels.lightingClassificationDataSheet;
});

const isMobileOrTablet = computed(() => {
    return breakpointsState.activeBreakpoint === 'xs' || breakpointsState.activeBreakpoint === 'sm';
});

const certificationImageUrl = computed(() => {
    if (props.productCertificationPrimary?.imageUrl) {
        return generateCdnUrlWithParams(
            props.productCertificationPrimary.imageUrl,
            { format: 'auto', width: 35 },
            true);
    }
    return null;
});

const lightingImageUrl = computed(() => {
    if (props.lightingSpecification?.energyClassification) {
        const energyLbl = props.lightingSpecification.energyClassification.toLowerCase();
        const directionParameter = isMobileOrTablet.value ? 'right' : 'left';
        const lightingUrl = `/layout/images/energy-labels/${energyLbl}-${directionParameter}.png`;

        return generateCdnUrlWithParams(
            lightingUrl,
            { format: 'auto', width: 38 },
            false);
    }
    return null;
});

const lightningAltText = computed(() => {
    if (props.lightingSpecification && props.lightingSpecification.energyClassification) {
        return dictionaryService.formatNamed(globalLabels.lightingClassification,
            { classification: props.lightingSpecification.energyClassification });
    }
    return undefined;
});


return (_ctx: any,_cache: any) => {
  return (_unref(lightingImageUrl) || _unref(showLink))
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        (_unref(lightingImageUrl))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("img", {
                src: _unref(lightingImageUrl),
                alt: _unref(lightningAltText),
                class: "self-end w-28 md:w-38"
              }, null, 8, _hoisted_3),
              (_unref(imageHasLink))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: __props.lightingSpecification?.energyClassificationUrl,
                    target: "_blank",
                    class: "absolute inset-0",
                    "aria-label": _unref(lightningAltText)
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (__props.lightingSpecification?.specificationUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: __props.lightingSpecification?.specificationUrl,
              class: "c-magic-line c-magic-line--underline text-dusty-grey hover:text-mine-shaft",
              target: "_blank"
            }, _toDisplayString(_unref(globalLabels).lightingClassificationDataSheet), 9, _hoisted_5))
          : _createCommentVNode("", true)
      ]))
    : (__props.productCertificationPrimary && _unref(certificationImageUrl))
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _createElementVNode("img", {
            src: _unref(certificationImageUrl),
            alt: __props.productCertificationPrimary.name,
            class: "w-25 sm:w-28 lg:w-30 xl:w-35"
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
}
}

})